// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Odjeli_wrapper__z0yea {
  padding: 90px;
}

.Odjeli_left__psUgB {
  width: 50%;
}

.Odjeli_newListItem__vpKSs {
  margin-left: -10px;
  margin-bottom: 0px;
}

.Odjeli_backtext__bVfEJ {
  font-family: "Open Sans";
  font-weight: 700;
  margin: auto 5px;
  padding-bottom: 2px;
  color: #9fa7b2;
}
.Odjeli_backimg__SwAbb {
  height: 24px;
  width: 24px;
}

.Odjeli_content__x2U0r {
  width: 100%;
  display: flex;
  gap: 100px;
  margin-top: 50px;
}

.Odjeli_right__NF6ui {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  width: 50%;
  justify-content: center;
  align-items: flex-end;
}

.Odjeli_doc__zddzo {
  background-color: #f7f7f7;
  border-radius: 8px;
  width: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px 0;
  margin-bottom: 20px;
  text-align: center;
}

.Odjeli_h3__0gwk7 {
  font-size: 20px;
  font-family: "Open Sans";
  font-weight: 700;
  color: #090446;
  margin: 0;
  width: 90%;
  text-align: center;
}

.Odjeli_list__m7Vc- {
  color: #747474;
  list-style-type: none;
}

.Odjeli_li__ri6kh {
  display: flex;
  align-items: center;
}

.Odjeli_crtica__Ag1O- {
  height: 2px;
  width: 20px;
  padding-right: 10px;
}

.Odjeli_p__ZitkP,
.Odjeli_pAgency__q6O3g {
  font-size: 16px;
  font-family: "Open Sans";
  font-weight: 400;
  color: #747474;
}

.Odjeli_backtext__bVfEJ:hover,
.Odjeli_backimg__SwAbb:hover {
  cursor: pointer;
}

.Odjeli_back__oiL7M {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 24px;
  padding-bottom: 20px;
}

.Odjeli_btnimg1__tUdOG,
.Odjeli_btnimg2__6hcH6 {
  height: 24px;
  width: 24px;
}

.Odjeli_btn1__HvvUF:hover,
.Odjeli_btn2__Mk248:hover {
  cursor: pointer;
}

.Odjeli_btn1__HvvUF:hover {
  background-color: #3175a8;
}

.Odjeli_btn2__Mk248:hover {
  background-color: #e6eaed;
}

.Odjeli_btn1__HvvUF,
.Odjeli_btn2__Mk248 {
  padding: 16px 24px;
  border-radius: 8px;
  border: none;
  gap: 8px;
  width: 65%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Odjeli_btntext__kmzG1 {
  font-size: 16px;
  font-family: "Lato";
  font-weight: 800;
}

.Odjeli_btn1__HvvUF {
  background-color: #47a9f4;
  color: white;
}

.Odjeli_btn2__Mk248 {
  background-color: transparent;
  color: #47a9f4;
  border: 2px solid #47a9f4;
  padding-right: 40px;
}

.Odjeli_listp__qwKsj {
  color: #47a9f4;
  font-family: "Open Sans";
  font-weight: 700;
  font-size: 20px;
}

.Odjeli_avion__LFqzq {
  display: flex;
  align-items: center;
  width: 50%;
}

.Odjeli_planeAgency__5yh7\\+ {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.Odjeli_verify__tmuDM {
  height: 24px;
  width: 24px;
  padding-right: 10px;
  padding-bottom: 5px;
}

.Odjeli_pAvion__xoXqP {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  color: #090446;
}

.Odjeli_plane__RpsL9 {
  display: flex;
  align-items: center;
}

.Odjeli_planeimg__M43IK {
  height: 70px;
  width: 70px;
  padding-right: 20px;
}

.Odjeli_novo__mQxZi {
  height: 32px;
  width: 88px;
  padding-right: 20px;
}

.Odjeli_pDoc__5wxDF {
  font-size: 16px;
  font-weight: 400;
  font-family: "Open Sans";
  line-height: 16px;
  color: #747474;
  text-align: center;
  width: 90%;
}

.Odjeli_avimg__-uaw\\+ {
  width: 400px;
  height: 260px;
  padding-right: 40px;
}

.Odjeli_pAgency__q6O3g {
  width: 400px;
  padding-right: 40px;
}
.Odjeli_h1__6HA1U {
  font-size: 36px;
  font-weight: 700;
  font-family: "Open Sans";
  color: #090446;
}

.Odjeli_dropdown__VGd8H,
.Odjeli_open__F8gER {
  padding: 15px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #47a9f4;
  font-size: 20px;
  font-weight: 700;
  font-family: "Open Sans";
}

.Odjeli_open__F8gER {
  color: #090446;
}

.Odjeli_dropdown__VGd8H:hover,
.Odjeli_open__F8gER:hover {
  cursor: pointer;
}

.Odjeli_dropContent__e9EHW {
  padding: 20px 30px 40px;
  color: #747474;
  font-size: 16px;
  font-weight: 400;
  font-family: "Open Sans";
}

.Odjeli_arrowDown__IxMu4 {
  height: 30px;
  width: 30px;
}

@media screen and (max-width: 1310px) {
  .Odjeli_h1__6HA1U {
    font-size: 34px;
  }
}

@media screen and (max-width: 1190px) {
  .Odjeli_content__x2U0r {
    flex-direction: column;
    padding: 0 5%;
    gap: 0px;
    width: 85%;
  }
  .Odjeli_right__NF6ui,
  .Odjeli_left__psUgB {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: left;
  }
  .Odjeli_avion__LFqzq {
    width: 85%;
  }
  .Odjeli_avimg__-uaw\\+ {
    padding-left: 0px;
  }
  .Odjeli_planeAgency__5yh7\\+ {
    padding-left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .Odjeli_pAgency__q6O3g {
    padding: 0;
  }
}

@media screen and (max-width: 775px) {
  .Odjeli_h1__6HA1U {
    font-size: 30px;
    text-align: left;
    width: 100%;
  }
  .Odjeli_plane__RpsL9 {
    flex-direction: column;
  }
  .Odjeli_doc__zddzo,
  .Odjeli_btn1__HvvUF,
  .Odjeli_btn2__Mk248 {
    width: 90%;
  }
}

@media screen and (max-width: 600px) {
  .Odjeli_h1__6HA1U {
    font-size: 28px;
  }
  .Odjeli_plane__RpsL9 {
    width: 100%;
  }
}

@media screen and (max-width: 550px) {
  .Odjeli_wrapper__z0yea {
    padding: 50px 10px;
    overflow: hidden;
  }
}

@media screen and (max-width: 475px) {
  .Odjeli_h1__6HA1U {
    font-size: 26px;
  }
  .Odjeli_avimg__-uaw\\+,
  .Odjeli_pAgency__q6O3g {
    width: 300px;
    padding-right: 0;
  }
}

@media screen and (max-width: 400px) {
  .Odjeli_h1__6HA1U {
    padding-left: 20px;
    padding-bottom: 15px;
  }
  .Odjeli_doc__zddzo,
  .Odjeli_btn1__HvvUF,
  .Odjeli_btn2__Mk248 {
    width: 95%;
    margin-left: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Odjeli/Odjeli.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,QAAQ;IACR,UAAU;EACZ;EACA;;IAEE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;;;IAGE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;;;IAGE,UAAU;IACV,iBAAiB;EACnB;AACF","sourcesContent":[".wrapper {\n  padding: 90px;\n}\n\n.left {\n  width: 50%;\n}\n\n.newListItem {\n  margin-left: -10px;\n  margin-bottom: 0px;\n}\n\n.backtext {\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  margin: auto 5px;\n  padding-bottom: 2px;\n  color: #9fa7b2;\n}\n.backimg {\n  height: 24px;\n  width: 24px;\n}\n\n.content {\n  width: 100%;\n  display: flex;\n  gap: 100px;\n  margin-top: 50px;\n}\n\n.right {\n  padding-top: 50px;\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  justify-content: center;\n  align-items: flex-end;\n}\n\n.doc {\n  background-color: #f7f7f7;\n  border-radius: 8px;\n  width: 65%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 20px 0;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.h3 {\n  font-size: 20px;\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  color: #090446;\n  margin: 0;\n  width: 90%;\n  text-align: center;\n}\n\n.list {\n  color: #747474;\n  list-style-type: none;\n}\n\n.li {\n  display: flex;\n  align-items: center;\n}\n\n.crtica {\n  height: 2px;\n  width: 20px;\n  padding-right: 10px;\n}\n\n.p,\n.pAgency {\n  font-size: 16px;\n  font-family: \"Open Sans\";\n  font-weight: 400;\n  color: #747474;\n}\n\n.backtext:hover,\n.backimg:hover {\n  cursor: pointer;\n}\n\n.back {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 24px;\n  padding-bottom: 20px;\n}\n\n.btnimg1,\n.btnimg2 {\n  height: 24px;\n  width: 24px;\n}\n\n.btn1:hover,\n.btn2:hover {\n  cursor: pointer;\n}\n\n.btn1:hover {\n  background-color: #3175a8;\n}\n\n.btn2:hover {\n  background-color: #e6eaed;\n}\n\n.btn1,\n.btn2 {\n  padding: 16px 24px;\n  border-radius: 8px;\n  border: none;\n  gap: 8px;\n  width: 65%;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btntext {\n  font-size: 16px;\n  font-family: \"Lato\";\n  font-weight: 800;\n}\n\n.btn1 {\n  background-color: #47a9f4;\n  color: white;\n}\n\n.btn2 {\n  background-color: transparent;\n  color: #47a9f4;\n  border: 2px solid #47a9f4;\n  padding-right: 40px;\n}\n\n.listp {\n  color: #47a9f4;\n  font-family: \"Open Sans\";\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.avion {\n  display: flex;\n  align-items: center;\n  width: 50%;\n}\n\n.planeAgency {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.verify {\n  height: 24px;\n  width: 24px;\n  padding-right: 10px;\n  padding-bottom: 5px;\n}\n\n.pAvion {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 400;\n  color: #090446;\n}\n\n.plane {\n  display: flex;\n  align-items: center;\n}\n\n.planeimg {\n  height: 70px;\n  width: 70px;\n  padding-right: 20px;\n}\n\n.novo {\n  height: 32px;\n  width: 88px;\n  padding-right: 20px;\n}\n\n.pDoc {\n  font-size: 16px;\n  font-weight: 400;\n  font-family: \"Open Sans\";\n  line-height: 16px;\n  color: #747474;\n  text-align: center;\n  width: 90%;\n}\n\n.avimg {\n  width: 400px;\n  height: 260px;\n  padding-right: 40px;\n}\n\n.pAgency {\n  width: 400px;\n  padding-right: 40px;\n}\n.h1 {\n  font-size: 36px;\n  font-weight: 700;\n  font-family: \"Open Sans\";\n  color: #090446;\n}\n\n.dropdown,\n.open {\n  padding: 15px 30px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: #47a9f4;\n  font-size: 20px;\n  font-weight: 700;\n  font-family: \"Open Sans\";\n}\n\n.open {\n  color: #090446;\n}\n\n.dropdown:hover,\n.open:hover {\n  cursor: pointer;\n}\n\n.dropContent {\n  padding: 20px 30px 40px;\n  color: #747474;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: \"Open Sans\";\n}\n\n.arrowDown {\n  height: 30px;\n  width: 30px;\n}\n\n@media screen and (max-width: 1310px) {\n  .h1 {\n    font-size: 34px;\n  }\n}\n\n@media screen and (max-width: 1190px) {\n  .content {\n    flex-direction: column;\n    padding: 0 5%;\n    gap: 0px;\n    width: 85%;\n  }\n  .right,\n  .left {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: left;\n  }\n  .avion {\n    width: 85%;\n  }\n  .avimg {\n    padding-left: 0px;\n  }\n  .planeAgency {\n    padding-left: 0px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .pAgency {\n    padding: 0;\n  }\n}\n\n@media screen and (max-width: 775px) {\n  .h1 {\n    font-size: 30px;\n    text-align: left;\n    width: 100%;\n  }\n  .plane {\n    flex-direction: column;\n  }\n  .doc,\n  .btn1,\n  .btn2 {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .h1 {\n    font-size: 28px;\n  }\n  .plane {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 550px) {\n  .wrapper {\n    padding: 50px 10px;\n    overflow: hidden;\n  }\n}\n\n@media screen and (max-width: 475px) {\n  .h1 {\n    font-size: 26px;\n  }\n  .avimg,\n  .pAgency {\n    width: 300px;\n    padding-right: 0;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .h1 {\n    padding-left: 20px;\n    padding-bottom: 15px;\n  }\n  .doc,\n  .btn1,\n  .btn2 {\n    width: 95%;\n    margin-left: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Odjeli_wrapper__z0yea`,
	"left": `Odjeli_left__psUgB`,
	"newListItem": `Odjeli_newListItem__vpKSs`,
	"backtext": `Odjeli_backtext__bVfEJ`,
	"backimg": `Odjeli_backimg__SwAbb`,
	"content": `Odjeli_content__x2U0r`,
	"right": `Odjeli_right__NF6ui`,
	"doc": `Odjeli_doc__zddzo`,
	"h3": `Odjeli_h3__0gwk7`,
	"list": `Odjeli_list__m7Vc-`,
	"li": `Odjeli_li__ri6kh`,
	"crtica": `Odjeli_crtica__Ag1O-`,
	"p": `Odjeli_p__ZitkP`,
	"pAgency": `Odjeli_pAgency__q6O3g`,
	"back": `Odjeli_back__oiL7M`,
	"btnimg1": `Odjeli_btnimg1__tUdOG`,
	"btnimg2": `Odjeli_btnimg2__6hcH6`,
	"btn1": `Odjeli_btn1__HvvUF`,
	"btn2": `Odjeli_btn2__Mk248`,
	"btntext": `Odjeli_btntext__kmzG1`,
	"listp": `Odjeli_listp__qwKsj`,
	"avion": `Odjeli_avion__LFqzq`,
	"planeAgency": `Odjeli_planeAgency__5yh7+`,
	"verify": `Odjeli_verify__tmuDM`,
	"pAvion": `Odjeli_pAvion__xoXqP`,
	"plane": `Odjeli_plane__RpsL9`,
	"planeimg": `Odjeli_planeimg__M43IK`,
	"novo": `Odjeli_novo__mQxZi`,
	"pDoc": `Odjeli_pDoc__5wxDF`,
	"avimg": `Odjeli_avimg__-uaw+`,
	"h1": `Odjeli_h1__6HA1U`,
	"dropdown": `Odjeli_dropdown__VGd8H`,
	"open": `Odjeli_open__F8gER`,
	"dropContent": `Odjeli_dropContent__e9EHW`,
	"arrowDown": `Odjeli_arrowDown__IxMu4`
};
export default ___CSS_LOADER_EXPORT___;
